import React from 'react';
import { TextInput } from '../ui/TextInput';
import { Select } from '../ui/Select';
import { CuotaInfoBlock } from '../CuotaInfoBlock';

export interface AportesValues {
  readonly aporte_mensual: string;
  readonly aporte_cuota_iglesia: string;
  readonly modo_pago_cuota_iglesia: string;
}

/** Cuota iglesia mínima sugerida (CLP). Se muestra como marca de agua y como texto de ayuda,
 *  nunca prellenada: el monto lo decide el miembro. */
const CUOTA_MINIMA_SUGERIDA = 5000;
const CUOTA_MINIMA_SUGERIDA_TEXTO = '$5.000';

interface ModoPagoOption { readonly value: string; readonly label: string; }

interface MiembroFieldsAportesProps {
  readonly values: AportesValues;
  readonly onFieldChange: (field: keyof AportesValues, value: string) => void;
  readonly errors: Record<string, string>;
  readonly required?: boolean;
  readonly modoPagoOptions: readonly ModoPagoOption[];
  readonly aporteMensualLabel?: string;
  readonly cuotaLabel?: string;
}

export const MiembroFieldsAportes: React.FC<MiembroFieldsAportesProps> = ({
  values, onFieldChange, errors, required = false, modoPagoOptions,
  aporteMensualLabel = 'Aporte mensual', cuotaLabel = 'Cuota iglesia',
}) => (
  <div className="space-y-4">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <TextInput label={aporteMensualLabel} type="number" min={0} step={1}
        value={values.aporte_mensual} onChange={(v) => onFieldChange('aporte_mensual', v)}
        error={errors.aporte_mensual} required={required} />
      <div>
        <TextInput label={cuotaLabel} type="number" min={0} step={1} placeholder={`${CUOTA_MINIMA_SUGERIDA}`}
          value={values.aporte_cuota_iglesia} onChange={(v) => onFieldChange('aporte_cuota_iglesia', v)}
          error={errors.aporte_cuota_iglesia} required={required} />
        <p className="mt-1 text-sm text-slate-500">
          Cuota mínima sugerida: {CUOTA_MINIMA_SUGERIDA_TEXTO}
        </p>
      </div>
    </div>
    <Select label="Modalidad cuota iglesia" value={values.modo_pago_cuota_iglesia}
      onChange={(v) => onFieldChange('modo_pago_cuota_iglesia', v)}
      error={errors.modo_pago_cuota_iglesia} required={required}
      placeholder="Selecciona..." options={[...modoPagoOptions]} />
    <CuotaInfoBlock />
  </div>
);
